import head from 'lodash/head';
import { NA_VALUE } from '@yme/common/constants';
import { checkMotorcyclesProductType } from '@yme/utils/productTypes';
import { STATUS_COLOR_CHANGE, STATUS_INIT, STATUS_RELOAD } from '../constants';
function initialMotorcyclesFilterOptions({ variantsOfProduct, }) {
    const activeVariant = variantsOfProduct.find((item) => {
        return [item.master, item.loweredVersion, item.power, item.transmission].every((i) => i);
    }) ||
        variantsOfProduct.find((item) => {
            return [
                item.master,
                item.loweredVersion,
                item.power,
                item.transmission,
                item.prices.amount > 0,
            ].every((i) => i);
        }) ||
        variantsOfProduct.find((item) => {
            return [
                item.loweredVersion,
                item.power,
                item.transmission,
                item.stock > 0,
                item.prices.amount > 0,
            ].every((i) => i);
        });
    return activeVariant;
}
function reloadMotorcyclesFilterOptions({ sku, variantsOfProduct, }) {
    return (variantsOfProduct.find((item) => [item.sku, item.sku === sku].every((i) => i)) ||
        variantsOfProduct.find((item) => [item.sku, item.loweredVersion, item.power, item.stock > 0].every((i) => i)));
}
function changeColorMotorcyclesFilterOptions({ variantsOfProduct, loweredVersion, power, transmission, }) {
    const activeVariant = variantsOfProduct.find((item) => {
        const res = [
            item.loweredVersion === loweredVersion,
            item.power === power,
            item.transmission === transmission,
        ].every((i) => i);
        return res;
    }) ||
        variantsOfProduct.find((item) => {
            const res = [item.power === power, item.transmission === transmission, item.stock > 0].every((i) => i);
            return res;
        }) ||
        variantsOfProduct.find((item) => {
            const res = [
                item.power === power,
                item.transmission === transmission,
                item.prices.amount > 0,
            ].every((i) => i);
            return res;
        }) ||
        head(variantsOfProduct);
    return activeVariant;
}
export function prepareMotorcyclesFilterOptions({ colorVariants, index = 0, loweredVersion = '', power = '', transmission = '', sku = '', statusType, }) {
    const currentProductType = colorVariants[index].productType
        .toUpperCase()
        .trim()
        .replace(' ', '')
        .replace('-', '');
    const commonProps = {
        colorItemIndex: index,
        colourId: colorVariants[index].colourId,
        productType: currentProductType,
    };
    const variantsOfProduct = colorVariants[index]?.variantsOfProduct;
    const isCurrentMotorcycles = Boolean(variantsOfProduct && checkMotorcyclesProductType(currentProductType));
    if (isCurrentMotorcycles) {
        let activeVariant;
        if (statusType === STATUS_INIT && !sku && !loweredVersion) {
            activeVariant = initialMotorcyclesFilterOptions({
                variantsOfProduct,
            });
        }
        if (statusType === STATUS_RELOAD && sku && !loweredVersion) {
            activeVariant = reloadMotorcyclesFilterOptions({
                variantsOfProduct,
                sku,
            });
        }
        if (statusType === STATUS_COLOR_CHANGE) {
            activeVariant = changeColorMotorcyclesFilterOptions({
                variantsOfProduct,
                loweredVersion,
                power,
                transmission,
            });
        }
        // Default/common cases - Show any variant by size in current ColorGroup (first result with compared condition)
        activeVariant =
            activeVariant ||
                variantsOfProduct.find((item) => item.stock > 0 && item.prices.amount > 0) ||
                variantsOfProduct.find((item) => item.prices.amount > 0);
        return {
            ...commonProps,
            sku: activeVariant?.sku || '',
            loweredVersion: activeVariant?.loweredVersion || '',
            power: activeVariant?.power || '',
            transmission: activeVariant?.transmission || '',
        };
    }
    return {
        ...commonProps,
        sku: '',
        loweredVersion: '',
        power: '',
        transmission: '',
    };
}
export function getAvailableSkuBase({ colorVariants, transmission, power, loweredVersion, }) {
    const exactCase = colorVariants?.find((item) => item.power === power &&
        item.transmission === transmission &&
        item.loweredVersion === loweredVersion &&
        item.stock > 0);
    const prettySuitableCase = colorVariants?.find((item) => item.power === power &&
        item.transmission === transmission &&
        item.loweredVersion === loweredVersion);
    const alternativeCase = colorVariants?.find((item) => item.power === power && item.transmission === transmission);
    return exactCase || prettySuitableCase || alternativeCase;
}
export function getAvailableSkuByPowerValue({ colorVariants, power, loweredVersion, }) {
    const partialMatchLoweredVersionCase = colorVariants?.find((item) => item.loweredVersion === loweredVersion && item.power === power);
    const powerCase = colorVariants?.find((item) => item.power === power);
    return partialMatchLoweredVersionCase || powerCase;
}
export const getAvailableSkuByLoweredVersionValue = ({ colorVariants, loweredVersionValue = '', transmissionValue = '', powerValue = '', }) => {
    const exactCase = colorVariants?.find((item) => item.power === powerValue &&
        item.transmission === transmissionValue &&
        item.loweredVersion === loweredVersionValue &&
        item.stock > 0 &&
        item.prices.amount > 0);
    const prettySuitableCase = colorVariants?.find((item) => item.power === powerValue &&
        item.transmission === transmissionValue &&
        item.loweredVersion === loweredVersionValue &&
        item.prices.amount > 0);
    const alternativeCase = colorVariants?.find((item) => item.power === powerValue &&
        item.transmission === transmissionValue &&
        item.loweredVersion === loweredVersionValue);
    return exactCase || prettySuitableCase || alternativeCase;
};
export function buildLoweredVersionList(options) {
    const res = options.reduce((acc, itemValue) => {
        if (itemValue !== NA_VALUE) {
            const itemOptions = {
                value: itemValue,
            };
            return [...acc, itemOptions];
        }
        return acc;
    }, []);
    return res;
}
export function getPossibleSLoweredVersionOptions(variants, power, transmission) {
    const possibleVariants = variants?.filter((variant) => variant.power === power && variant.transmission === transmission);
    const possibleSLoweredVersionOptions = possibleVariants?.map((variant) => variant.loweredVersion);
    return possibleSLoweredVersionOptions ?? [];
}
export const getSortedLoweredVersionVariationsValues = (versions, secondVariant = '') => {
    if (versions.length > 0 && versions[0].value !== secondVariant) {
        return versions;
    }
    return [...versions].reverse();
};
